<div style="width: 90% !important; margin: auto;padding-left: 150px;">
    <div id="dashboardContainerSmartSummary"></div>
  </div>